import budi from '../images/Budi Yuli Setianto, MD, PhD.webp';
import irmalita from '../images/Irmalita, MD.webp';
import daniel from '../images/Daniel PL Tobing, MD.webp';
import isman from '../images/Isman Firdaus, MD, PhD.webp';
import safir from '../images/Safir Sungkar, MD.webp';
import viena from '../images/Vienna Rossimarina, MD.webp';
import diah from '../images/Diah Retno Widowati.webp';
import vidya from '../images/Vidya Gilang Rejeki, MD.webp';
import hendry from '../images/Hendry Purnasidha Bagaswoto, MD.webp';
import dafsah from '../images/Dafsah Arifa Juzar, MD, PhD.webp';
import syaifur from '../images/M. Saifur Rohman, MD.webp';
import siska from '../images/Siska Suridanda Danny, MD.webp';
import bambang from '../images/Bambang Widyantoro, MD, PhD.webp';
import yusuf from '../images/M. Yusuf Alsagaff, MD.webp';
import ismir from '../images/dr Ismir, SpJP(K).webp';
import dewi from '../images/dr. Dewi Utari Djafar SpJP(K).webp';
import miftah from '../images/Miftah Pramudyo.webp';
import akhtar from '../images/Akhtar Fajar Muzakkir, MD.webp';
import bimo from '../images/Bimo Bintoro.webp';
import yose from '../images/Yose Ramda Ilhami.webp';
import setya from '../images/Setyasih Anjarwani, MD.webp';
import rita from '../images/Rita Zahara, MD, PhD.webp';
import rien from '../images/Rien Afrianti.webp';
import fadil from '../images/fadil.webp';
import adiBestara from '../images/Adi Bestara.webp';
import marshell from '../images/Marshell Luntungan, MD.webp';
import andrew from '../images/dr Andrew Parlautan.webp';
import indra from '../images/Indra Prasetya, MD.webp';
import jusuf from '../images/Jusup Endang, MD.webp';
import rony from '../images/Rony Mario Candrasatria, MD.webp';
import firandy from '../images/Firandi Saputra.webp';
import dian from '../images/Dian Zamroni, MD.webp';
import faisal from '../images/Faisal Habib, MD.webp';
import ahnaf from '../images/Fauziar Ahnaf.webp';
import evita from '../images/Evita Devi Noor R.webp';

export const BOARD_MEMBER_DATA = [
    {
        section: 'Steering Committee',
        roles: [
            {
                position: 'Advisory',
                member: [
                    {
                        name: 'Prof. Budi Yuli Setianto, MD, Ph.D',
                        image: budi,
                    },
                    {
                        name: 'Irmalita, MD',
                        image: irmalita,
                    },
                    {
                        name: 'Daniel PL Tobing, MD',
                        image: daniel,
                    },
                    {
                        name: 'Isman Firdaus, MD, Ph.D',
                        image: isman,
                    },
                ],
            },
            {
                position: 'Chairman',
                member: [
                    {
                        name: 'Safir Sungkar, MD',
                        image: safir,
                    },
                ],
            },
            {
                position: 'Co-Chairman',
                member: [
                    {
                        name: 'M. Fauziar Ahnaf, MD',
                        image: ahnaf,
                    },
                ],
            },
            {
                position: 'Secretary',
                member: [
                    {
                        name: 'Vienna Rossimarina, MD',
                        image: viena,
                    },
                ],
            },
            {
                position: 'Treasurer',
                member: [
                    {
                        name: 'Diah Retno Widowati, MD',
                        image: diah,
                    },
                    {
                        name: 'Vidya Gilang Rejeki, MD',
                        image: vidya,
                    },
                ],
            },
        ],
    },
    {
        section: 'Scientific Committee',
        roles: [
            {
                position: 'Chairman Members',
                member: [
                    { name: 'Hendry Purnasidha Bagaswoto, MD', image: hendry },
                    { name: 'Dafsah Arifa Juzar, MD, Ph.D', image: dafsah },
                    { name: 'Prof. Saifur Rohman, MD, Ph.D', image: syaifur },
                    { name: 'Siska Suridanda Danny, MD', image: siska },
                    { name: 'Bambang Widiyantoro, MD, Ph.D', image: bambang },
                    { name: 'Mochamad Yusuf, MD, Ph.D', image: yusuf },
                    { name: 'Ismir Fahri, MD', image: ismir },
                    { name: 'Tri Astiawati, MD, Ph.D' },
                    { name: 'Dewi Utari Djafar, MD', image: dewi },
                    { name: 'Miftah Pramudyo, MD', image: miftah },
                    { name: 'Akhtar Fajar Muzakkir, MD', image: akhtar },
                    { name: 'Bimo Bintoro, MD', image: bimo },
                    { name: 'Yose Ramda Ilhami, MD, Ph.D', image: yose },
                ],
            },
            {
                position: 'Workshop Coordinator',
                member: [
                    { name: 'Setyasih Anjarwani, MD', image: setya },
                    { name: 'Rita Zahara, MD, Ph.D', image: rita },
                ],
            },
        ],
    },
    {
        section: 'Organizing Committee',
        roles: [
            {
                position: 'Publication, Promotion, & Documentation',
                member: [
                    { name: 'Rien Afrianti, MD', image: rien },
                    { name: 'Muhammad Fadil, MD, Ph.D', image: fadil },
                    { name: 'Evita Devi Noor R, MD', image: evita },
                ],
            },
            {
                position: 'Accomodation & Transportation',
                member: [{ name: 'Adi Bestara, MD', image: adiBestara }],
            },
            {
                position: 'Exhibition',
                member: [
                    { name: 'Marshell Luntungan, MD', image: marshell },
                    { name: 'Andrew Parlautan, MD', image: andrew },
                ],
            },
            {
                position: 'Registration, IT, & Audiovisual',
                member: [
                    { name: 'Indra Prasetya, MD', image: indra },
                    { name: 'Jusup Endang, MD', image: jusuf },
                    { name: 'Hendy Wirawan, MD' },
                ],
            },
            {
                position: 'Free Paper & Poster Session',
                member: [
                    { name: 'Rony Mario Candrasatria, MD', image: rony },
                    { name: 'Firandi Saputra, MD', image: firandy },
                ],
            },
            {
                position: 'Rundown Coordinator',
                member: [
                    { name: 'Dian Zamroni, MD', image: dian },
                    { name: 'Faisal Habib, MD', image: faisal },
                ],
            },
        ],
    },
];
